import { type PayloadAction, createReducer } from '@reduxjs/toolkit';
import { isFolder } from 'reactApp/modules/file/utils';
import { renameItemSuccess } from 'reactApp/modules/modifying/modifying.actions';
import type { IRenameItemSuccess } from 'reactApp/modules/modifying/modifying.types';

import { loadDomainFoldersSuccess } from './domainFolders.actions';
import type { ApiDomainFoldersResponse, DomainFoldersState } from './domainFolders.types';

const initialState: DomainFoldersState = {
    list: {},
};

export const domainFoldersReducer = createReducer(initialState, {
    [loadDomainFoldersSuccess.type]: (state, action: PayloadAction<ApiDomainFoldersResponse | undefined>) => {
        const domainFolders = action.payload;

        (domainFolders ?? []).forEach((folder) => {
            state.list[folder.home.toLowerCase()] = {
                __reduxTree: true,
                id: folder.home,
                name: folder.name,
                size: folder.size,
                mode: folder.mode,
                mode_bitmask: folder.mode_bitmask,
                home: folder.home,
                quota: folder.quota,
                tree: folder.tree,
                icon: '',
                href: '',
                text: '',
            };
        });
    },
    [renameItemSuccess.type]: (state, action: PayloadAction<IRenameItemSuccess>) => {
        const { newItem, oldId } = action.payload;

        if (!isFolder(newItem)) {
            return;
        }

        const lowerOldId = oldId?.toLowerCase();
        const domainFolder = state.list?.[lowerOldId];

        if (!domainFolder || !newItem.home) {
            return;
        }

        delete state.list[lowerOldId];
        state.list[newItem.home.toLowerCase()] = {
            ...domainFolder,
            id: newItem.home,
            name: newItem.name,
        };
    },
});
